import { EventEmitter, Injectable } from '@angular/core'
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { SpeciesService } from '../../../services/species.service'
import { ISpecies } from 'src/app/models/Species'

@Injectable({ providedIn: 'root' })
export class SpeciesResolver implements Resolve<Observable<Array<ISpecies>>> {
	constructor(private speciesService: SpeciesService) {}
		public static alreadyLoaded = new EventEmitter<boolean>()

	public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
				SpeciesResolver.alreadyLoaded.emit(false)
		  try {
						const response: Array<ISpecies> = await this.speciesService.getSpeciesSimple().toPromise()
						SpeciesResolver.alreadyLoaded.emit(true)

			   return response
		} catch (err) {}
	}
}
